<template>
  <div class="users container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"/>
        <div class="columns is-centered">
            <div class="card-container">
              <!--ACCOUNT INFORMATION-->
              <h1 class="title">Account Information</h1>
              <router-link class="button is-danger is-fullwidth is-outlined" :to="{ name: 'home'}">Cancel</router-link>
              <div class="margin-bottom-2-rem">
                <b-field label="Email" >
                  <b-input type="test" name="email" v-model="email" required/>
                </b-field>
                <b-field label="Username">
                  <b-input type="test" name="username" v-model="username" required/>
                </b-field>
                <div class="block-full-width">
                  <button :disabled="requiredFieldsEmpty" class="button is-success is-half" @click="onSubmit">Update Account Information</button>
                </div>
              </div>

              <hr>

              <!--PASSWORD INFORMATION-->
              <div class="margin-top-2-rem">
                <b-field label="Original Password" >
                  <b-input type="password" name="originalPassword" v-model="passwordData.originalPassword" required/>
                </b-field>
                <b-field label="New Password">
                  <b-input type="password" name="newPassword" v-model="passwordData.newPassword" required/>
                </b-field>
                <b-field label="Confirm Password">
                  <b-input type="password" name="confirmPassword" v-model="passwordData.confirmPassword" required/>
                </b-field>
                <p class="has-text-danger">{{passwordMatchMsg}}</p>
                <div class="block-full-width">
                  <button :disabled="passwordMatchMsg" class="button is-success is-half" @click="saveNewPassword">Change Password</button>
                </div>
              </div>

            </div>
        </div>
  </div>
</template>

<script>
// @ is an alias to /src
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'


import { mapGetters } from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'accountInformationForm',

  data () {
    return {
        recID: this.$route.params.recID,
        email: null,
        username: null,
        errorMsg: null,
        userID: this.$route.params.userID,
        isLoading: false,
        isFullPage: true,
        notificationDuration: 4000,
        passwordData: {
            recID: this.$route.params.recID,
            originalPassword: null,
            newPassword: null,
            confirmPassword: null
        },
    }
  },
  
  computed: {
     ...mapState([
      'existingPassword'
    ]),


    requiredFieldsEmpty: function(){
        if(this.email == null || this.username == null){
            return true
        }
        else{
            return false
        }
    },


    passwordMatchMsg: function(){
      if (this.passwordData.originalPassword){
        if (this.passwordData.newPassword === this.passwordData.originalPassword){
          return "New password cannot match existing password"
        }
        else if( this.passwordData.newPassword == null || this.passwordData.confirmPassword == null ){
          return null;
        }
        else if ( this.passwordData.newPassword === this.passwordData.confirmPassword ){
          return null;
        }
        else{
          return "Passwords do not match";
        }
      }
    }
  },
  
  created() {
    this.getAccountInformation();
  },
  
  methods:{

    /**
    *GET ACCOUNT INFORMATION FROM FILEMAKER
    */
    getAccountInformation: async function(){
      this.isLoading = true
      var scriptParameters = `{
        "userID" : "${this.userID}"
      }`
      const result = await sharedAPI.runScript("User - Get Account Information", scriptParameters)
      this.isLoading = false;
      var scriptResult = JSON.parse(result.response.scriptResult)
      var jsonData = JSON.parse(scriptResult.result)
      console.log(jsonData)
      // FM error
      if(result.messages[0].code !== "0"){
        this.$snotify.error(result.messages[0].message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }  
      // Script error
      if(scriptResult.code != 0){
        this.$snotify.error( scriptResult.message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }

      this.email = jsonData.email;
      this.username = jsonData.username;
    },

    
    /**
    * TO SAVE INFORMATION TO FILEMAKER
    */
    onSubmit: async function(){
      this.isLoading = true
      var scriptParameters = `{
        "username" : "${this.username}",
        "email" : "${this.email}",
        "userID" : "${this.userID}"
      }`
      const result = await sharedAPI.runScript("User - Update Account Information", scriptParameters);
      var scriptResult = JSON.parse(result.response.scriptResult)
      this.isLoading = false
      // FM error
      if(result.messages[0].code !== "0"){
        this.$snotify.error(result.messages[0].message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }  
      // Script error
      if(scriptResult.code != 0){
        this.$snotify.error( scriptResult.message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }
     
      this.$snotify.success(scriptResult.message, "Success",
        {
          showProgressBar: false,
          position: 'rightBottom',
          icon: false,
          timeout: this.notificationDuration,
          closeOnClick: true,
          bodyMaxLength: 1000
        }
      )

    },


    /**
     * SAVE PASSWORD CHANGES TO FILEMAKER
     */
    saveNewPassword: async function(){
      this.isLoading = true
      var scriptParameters = `{
        "passwordOld" : "${this.passwordData.originalPassword}",
        "passwordNew" : "${this.passwordData.confirmPassword}",
        "userID" : "${this.userID}"
      }`
      console.log(scriptParameters)
      const result = await sharedAPI.runScript("User - Change Password", scriptParameters)
      console.log(result)
      var scriptResult = JSON.parse(result.response.scriptResult)
      this.isLoading = false
      // FM error
      if(result.messages[0].code !== "0"){
        this.$snotify.error(result.messages[0].message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }  
      // Script error
      if(scriptResult.code != 0){
        this.$snotify.error( scriptResult.message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: this.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }
     
      this.$snotify.success(scriptResult.message, "Success",
        {
          showProgressBar: false,
          position: 'rightBottom',
          icon: false,
          timeout: this.notificationDuration,
          closeOnClick: true,
          bodyMaxLength: 1000
        }
      )
      
      store.state.userInfo.isPasswordChangeNeeded = false
        if(this.$route.query.redirect){
            this.isLoading = false
            this.$router.replace( this.$route.query.redirect)
        }
        else{
            this.isLoading = false
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .button.is-danger{
    margin-bottom: 20px;
  }
  .button.is-outlined{
    border-color: #7F1E27;
    color: #7F1E27;
  }
  .button.is-outlined:hover{
    border-color: #7F1E27;
    background-color: #7F1E27;
    color: #ffffff;
  }
  input{
    margin-bottom: 15px;
  }
  .is-danger{
    margin-right: 10px;
  }
  .card-container {
    padding: 2rem;
    margin: 10px 20px 20px 20px;
  }  
  .page-title{
    margin: 0px 10px 0px 10px;
  }
  .columns-button{
     margin: 0px;
  }
  .column-button-left{
    padding: 0px;
  }
  .column-button-right{
    padding: 0px;
    flex: none;
  }
  .block-full-width{
    display: block;
    width: 100%;
  }
  .half-width{
    width: 50%;
  }
  .justify-content-between{
    display:flex;
    justify-content: space-between;
  }
@media only screen and (min-width: 300px) {
  .columns-button{
     margin-top: 30px;
  }
  .column-button-left{
    padding: 0px;
    width: 100%;
  }
  .column-button-right{
    padding: 0px;
    width: 100%;
  }
  .button.is-primary{
    margin-top: 10px;
    width: 100%;
  }
  .margin-bottom-2-rem{
    margin-bottom: 2rem !important;
  }
  .margin-top-2-rem{
    margin-top: 2rem !important;
  }
}
</style>